import React, { useState } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../buttons/IconButton';
import './CollapsibleWordList.css';
import { WordList } from './WordList';

interface CollapsibleWordListProps {
  words: string[];
  onWordClick?: (word: string) => void;
}

export const CollapsibleWordList: React.FC<CollapsibleWordListProps> = ({
  words,
  onWordClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-word-list ${isExpanded ? 'expanded' : ''}`}>
      <div className="collapsible-header" onClick={toggleExpand}>
        <span className="label-normal">Words Used ({words.length})</span>
        <IconButton
          icon={isExpanded ? faChevronUp : faChevronDown}
          size="1x"
          color="var(--dark-green)"
        />
      </div>
      {isExpanded && (
        <div className="collapsible-content">
          <WordList words={words} />
        </div>
      )}
    </div>
  );
};

export default CollapsibleWordList; 